import { useEffect, useRef } from 'react';

export const useAutoWidthCell = (index: number) => {
  const sourceElementRef = useRef<HTMLDivElement>(null);
  const targetElementRef = useRef<HTMLTableCellElement>(null);

  useEffect(() => {
    if (
      // we need to set a fixed width only for the first element and the rest of the cells will follow suit
      index === 0 &&
      sourceElementRef.current &&
      targetElementRef.current &&
      sourceElementRef.current.offsetWidth !== targetElementRef.current.offsetWidth
    ) {
      const trackedElementWidth = sourceElementRef?.current?.offsetWidth;
      targetElementRef.current.style.width = trackedElementWidth + 'px';
    }
  }, [index]);

  return { sourceElementRef, targetElementRef };
};
